export const REDUCE_BROKERCOMPANY_ELEMENT = 'REDUCE_BROKERCOMPANY_ELEMENT';
export const REDUCE_BROKERCOMPANY = 'REDUCE_BROKERCOMPANY';
export const GET_BROKERCOMPANY = 'GET_BROKERCOMPANY';
export const UPDATE_BROKERCOMPANY = 'UPDATE_BROKERCOMPANY';
export const QUERY_BROKERCOMPANIES = 'QUERY_BROKERCOMPANIES';
export const EXECUTE_BROKERCOMPANY_ACTION = 'EXECUTE_BROKERCOMPANY_ACTION';
export const REDUCE_BROKER_COMPANY_QUERY_ELEMENT = 'REDUCE_BROKER_COMPANY_QUERY_ELEMENT';
export const REDUCE_BROKERCOMPANIES = 'REDUCE_BROKERCOMPANIES';
export const REDUCE_ENTITY = 'REDUCE_ENTITY';

export const GET_BROKERCOMPANY_FEES = 'GET_BROKERCOMPANY_FEES';
export const UPSERT_BROKERCOMPANY_FEE = 'UPSERT_BROKERCOMPANY_FEE';
export const REDUCE_BROKERCOMPANY_FEE = 'REDUCE_BROKERCOMPANY_FEE';

export const GET_BROKERCOMPANY_PRODUCTS = 'GET_BROKERCOMPANY_PRODUCTS';
export const UPSERT_BROKERCOMPANY_PRODUCT = 'UPSERT_BROKERCOMPANY_PRODUCT';
export const DELETE_BROKERCOMPANY_PRODUCT = 'DELETE_BROKERCOMPANY_PRODUCT';
export const REDUCE_BROKERCOMPANY_PRODUCT = 'REDUCE_BROKERCOMPANY_PRODUCT';
export const GET_BROKER_COMPANY_BY_GUID = 'GET_BROKER_COMPANY_BY_GUID';

export const GET_BROKERCOMPANY_STOREFRONTS = 'GET_BROKERCOMPANY_STOREFRONTS';

export const REDUCE_FILE_UPLOADS_HISTORY = 'REDUCE_FILE_UPLOADS_HISTORY';
export const GET_FILE_UPLOADS_HISTORY = 'GET_FILE_UPLOADS_HISTORY';

export const REDUCE_BROKER_UPLOADS_HISTORY = 'REDUCE_BROKER_UPLOADS_HISTORY';
export const GET_BROKER_UPLOADS_HISTORY = 'GET_BROKER_UPLOADS_HISTORY';

export const GET_BILLING_DASHBOARD = 'GET_BILLING_DASHBOARD';
export const REDUCE_BILLING_DASHBOARD = 'REDUCE_BILLING_DASHBOARD';

export const GET_SMO_BROKER_DASHBOARD_V2 = 'GET_SMO_BROKER_DASHBOARD_V2';
export const REDUCE_SMO_BROKER_DASHBOARD_V2 = 'REDUCE_SMO_BROKER_DASHBOARD_V2';
export const RESET_SMO_BROKER_DASHBOARD_V2 = 'RESET_SMO_BROKER_DASHBOARD_V2';
export const FINALIZE_SMO_QUOTE = 'FINALIZE_SMO_QUOTE';
export const GET_SMO_DOCUMENT_DOWNLOAD_URL = 'GET_SMO_DOCUMENT_DOWNLOAD_URL';
export const VIEW_SMO_DOCUMENT = 'VIEW_SMO_DOCUMENT';
export const REDUCE_SMO_DOCUMENT_PREVIEW = 'REDUCE_SMO_DOCUMENT_PREVIEW';
export const SHARE_SMO_DOCUMENT = 'SHARE_SMO_DOCUMENT';
export const FOLLOWUP_SMO_QUOTE = 'FOLLOWUP_SMO_QUOTE';

// Campaigns
export const GET_CAMPAIGNS = 'GET_CAMPAIGNS';
export const REDUCE_CAMPAIGNS = 'REDUCE_CAMPAIGNS';
export const UPSERT_CAMPAIGNS = 'UPSERT_CAMPAIGNS';

// Template Editor
export const GET_TEMPLATE_EDITOR_DRAFTS = 'GET_TEMPLATE_EDITOR_DRAFTS';
export const UPDATE_TEMPLATE_EDITOR_DRAFTS = 'UPDATE_TEMPLATE_EDITOR_DRAFTS';
export const PUBLISH_TEMPLATE_EDITOR = 'PUBLISH_TEMPLATE_EDITOR';
export const REDUCE_TEMPLATE_EDITOR_DRAFTS = 'REDUCE_TEMPLATE_EDITOR_DRAFTS';

// Default Broker
export const GET_DEFAULT_BROKER = 'GET_DEFAULT_BROKER';
export const SET_DEFAULT_BROKER = 'SET_DEFAULT_BROKER';
export const REDUCE_DEFAULT_BROKER_GUID = 'REDUCE_DEFAULT_BROKER_GUID';

// Non-Subscriber Template Editor (Free Account Templates)
export const GET_NON_SUBSCRIBER_TEMPLATE_EDITOR_DRAFTS = 'GET_NON_SUBSCRIBER_TEMPLATE_EDITOR_DRAFTS';
export const UPDATE_NON_SUBSCRIBER_TEMPLATE_EDITOR_DRAFTS = 'UPDATE_NON_SUBSCRIBER_TEMPLATE_EDITOR_DRAFTS';
export const PUBLISH_NON_SUBSCRIBER_TEMPLATE_EDITOR = 'PUBLISH_NON_SUBSCRIBER_TEMPLATE_EDITOR';
export const COPY_NON_SUBSCRIBER_TEMPLATE = 'COPY_NON_SUBSCRIBER_TEMPLATE';
